import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-schedule",
  "use": "svgIcon-schedule-usage",
  "viewBox": "0 0 510 510",
  "content": "<symbol viewBox=\"0 0 510 510\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-schedule\"><path d=\"m255 0c-140.25 0-255 114.75-255 255s114.75 255 255 255 255-114.75 255-255-114.75-255-255-255zm0 459c-112.2 0-204-91.8-204-204s91.8-204 204-204 204 91.8 204 204-91.8 204-204 204z\" fill=\"currentColor\" /><path d=\"m267.75 127.5h-38.25v153l132.6 81.6 20.4-33.15-114.75-68.85z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol